import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as LogoSvg } from 'assets/svg/mobil_logo.svg';

const Wrapper = styled.div`
  svg {
    height: 1em;
    display: block;
  }
`;

const Logo = ({ className }) => {
  const classes = ['Logo'];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(' ')}>
      <LogoSvg />
    </Wrapper>
  );
};

Logo.displayName = 'Logo';

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: null,
};

export default Logo;
